// extracted by mini-css-extract-plugin
export default {"formContainer":"UserForm_formContainer__TloTd","form":"UserForm_form__C0k13","label":"UserForm_label__GcZTw","required":"UserForm_required__PhrFc"};